export const styles = {
  title: {
    fontSize: 20,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    fontWeight: '700',
  },
  subTitle: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    fontWeight: '700',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      marginBottom: 20,
    },
  },
  alignCenter: {
    textAlign: 'center',
  },
  noRequestText: {
    fontSize: 18,
    textAlign: 'center',
    color: '#707087',
  },
}
